import React, { useState } from 'react';
import { Building2, Globe } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

/** "ip · network" under a punch time; a saved office IP shows the office name instead. */
export const IpLine = ({ ip, network, office, testId }) => (
  <div className="text-[11px] text-gray-500 flex items-center gap-1" data-testid={testId}>
    {office ? (
      <><Building2 className="w-3 h-3 text-emerald-600" /><span className="text-emerald-700 font-medium" data-testid={`${testId}-office`}>{office}</span>{ip && <span className="text-gray-400">· {ip}</span>}</>
    ) : (
      <><Globe className="w-3 h-3" />{ip ? `${ip}${network ? ` · ${network}` : ''}` : 'IP not available'}</>
    )}
  </div>
);

/** Small selfie thumbnail; tap to see it full size. */
export const SelfieThumb = ({ url, label, testId }) => {
  const [open, setOpen] = useState(false);
  if (!url) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="shrink-0 rounded-full ring-2 ring-white shadow hover:scale-105 transition-transform" data-testid={testId}>
        <img src={url} alt={label} className="w-9 h-9 rounded-full object-cover" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid={`${testId}-dialog`} aria-describedby={undefined}>
          <DialogHeader><DialogTitle>{label}</DialogTitle><DialogDescription className="sr-only">Selfie</DialogDescription></DialogHeader>
          <img src={url} alt={label} className="w-full rounded-lg object-contain max-h-[70vh]" data-testid={`${testId}-full`} />
        </DialogContent>
      </Dialog>
    </>
  );
};
